<script>
  // import Swiper core and required modules
  import SwiperCore, {
    A11y,
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
  } from "swiper";
  import { Swiper, SwiperSlide } from "swiper/svelte";
  import NavCategories from "./components/navbar/NavCategories.svelte";

  // install Swiper modules
  SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

  let imagePaths = [
    {
      src:
        "images/plane1.jpg",
      position: "center",
    },
    {
      src:
        "images/plane2.jpg",
      position: "center",
    },
    {
      src:
        "images/plane3.avif",
      position: "center",
    },
    {
      src:
        "images/plane4.avif",
      position: "top",
    },
    {
      src:
        "images/plane5.avif",
      position: "center",
    },
    {
      src:
        "images/plane6.jpg",
      position: "center",
    },
  ];
</script>

<div class="relative">
  <Swiper
    spaceBetween={5}
    slidesPerView={1}
    navigation
    pagination
    loop
    autoplay={{ delay: 2500, disableOnInteraction: false }}
    watchSlidesVisibility
    watchSlidesProgress
    on:slideChange={() => console.log("slide change")}
  >
    {#each imagePaths as image}
      <SwiperSlide>
        <div
          style="background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
        url({image.src}); background-position: {image.position}"
          class="module mid w-full bg-center"
        >
          <h2 class="bg-gradient-to-r from-green-500 to-blue-500  ">
            Aviokimpex
          </h2>
        </div>
      </SwiperSlide>
    {/each}
  </Swiper>
  <NavCategories />
</div>

<style>
  .mid h2 {
    font-family: "Roboto", sans-serif;
    font-weight: 900;
    color: white;
    text-transform: uppercase;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 2rem;
    transform: translate(-50%, -50%);
  }
  .module {
    background-size: cover;
    background-position: center;
    height: 66vh;

    position: relative;
    float: left;
  }
</style>
